import { UniformFilterObject } from "./types";

export const countActiveFilterOptions = (
    filterId: string,
    state: UniformFilterObject
): number =>
    Object.values(state[filterId] ?? {}).reduce(
        (count, option) => (option.committedActive ? count + 1 : count),
        0
    );
